export const TOOLTIP_DEBOUNCE = 250;

export const BAR_MARGIN_DEFAULT = 2;
export const BAR_WIDTH_MIN = 4;
export const BAR_HEIGHT_MIN = 4;

export const GENOME_EVENT_COLOR_DEFAULT = "#000000";
